export const FAQData = [
  {
    question:
      "Da li mogu da počnem da treniram kod vas ako nikad pre nisam nista trenirao?",
    answer:
      "Naravno da možeš štaviše imamo savršen program za tebe “Počni od nule” tromesečna obuka namenjena ljudima koji nikad nisu trenirali ništa pre.",
  },
  {
    question: "Šta mi je potrebno od opreme da počnem da treniram?",
    answer:
      "Potrebni su ti šorc, majica i guma za zube. Na sreću sve to možeš da kupiš kod nas, a ako uplatiš program “Počni od nule” dobijaš svo troje na poklon.",
  },
  {
    question: "Da li mogu da počnem da treniram sa “X” godina?",
    answer:
      "Imamo treninge za sve uzraste od 3 do 103 nikad nije prerano ili prekasno da počneš da treniraš.",
  },
  {
    question: "Da li mogu da smršam od borilačkih treninga?",
    answer:
      "Naravno svi borilački treninzi iziskuju ogromnu potrošnju kalorija. Ako uz to koriguješ ishranu rezultati su zagarantovani.",
  },
];
